import { useL10n } from '@uplift/hooks';
import { CancelButton, FormModal, ModalActions, ModalContent, SubmitButton, TextInput } from '@uplift/ui-v2';
import { Formik } from 'formik';
import { useCallback } from 'react';

export type PsychReferralModalProps = {
  patientName: string;
  open: boolean;
  onClose: (note?: string) => void;
};

type ReferralModalForm = {
  email: string;
};

export const PsychReferralModal: React.VFC<PsychReferralModalProps> = ({ patientName, open, onClose }) => {
  const l10n = useL10n();
  const initial: ReferralModalForm = {
    email: l10n.dashboard.actionItems.patientFilledAssessment.modal.emailTemplate(patientName)
  };

  const handleSubmit = useCallback((values: ReferralModalForm) => {
    onClose(values.email);
  }, [ onClose ]);

  const handleClose = useCallback(() => {
    onClose();
  }, [ onClose ]);

  return (
    <Formik initialValues={initial} onSubmit={handleSubmit}>
      {formik => (
        <FormModal
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth="md"
          title={l10n.dashboard.actionItems.patientFilledAssessment.modal.title(patientName)}
          subtitle={l10n.dashboard.actionItems.patientFilledAssessment.modal.subtitle}
        >
          <ModalContent>
            <TextInput
              name="email"
              label={l10n.dashboard.actionItems.patientFilledAssessment.modal.formLabel(patientName)}
              color="secondary"
              fullWidth
              multiline
            />
          </ModalContent>
          <ModalActions>
            <CancelButton onClick={handleClose}>{l10n.dashboard.actionItems.patientFilledAssessment.modal.cancel}</CancelButton>
            <SubmitButton
              color="secondary"
              disabled={!formik.isValid || formik.isSubmitting}
              loading={formik.isSubmitting}
            >
              {l10n.dashboard.actionItems.patientFilledAssessment.modal.submit}
            </SubmitButton>
          </ModalActions>
        </FormModal>
      )}
    </Formik>
  );
};
